export default __webpack_public_path__ + "static/media/posture_trac.8b958945.png";